export const promoFetchTimer = 300000; // 5 minutes in milliseconds